import { RefObject, useEffect, useLayoutEffect } from "react";

/**
 * Module-level scroll position. Resets on full page reload (unlike
 * sessionStorage) but persists when navigating between sidebar and a chat
 * detail page, so the user comes back to where they were.
 */
let savedScrollPosition = 0;

export const usePlaygroundSidebarScroll = (
  scrollContainerRef: RefObject<HTMLDivElement>,
  loading: boolean,
  sessionId: string | undefined
) => {
  useLayoutEffect(() => {
    if (loading) return;
    const container = scrollContainerRef.current;
    if (container && savedScrollPosition > 0) {
      requestAnimationFrame(() => {
        container.scrollTop = savedScrollPosition;
      });
    }
  }, [scrollContainerRef, loading, sessionId]);

  useEffect(() => {
    const container = scrollContainerRef.current;
    if (!container) return;
    const handleScroll = () => {
      savedScrollPosition = container.scrollTop;
    };
    container.addEventListener("scroll", handleScroll, { passive: true });
    return () => container.removeEventListener("scroll", handleScroll);
  }, [scrollContainerRef]);
};
